import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

const PERCENTAGE_REGEXP = /(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/;
export function PercentageValidator():ValidatorFn {
    return (c:AbstractControl): ValidationErrors | null => {
        return PERCENTAGE_REGEXP.test(c.value) ? null : { validatePercentage: true };
    }
}